import React from 'react'
import PropTypes from 'prop-types'

import useRect from '../hooks/useRect'

// TODO: improve API to set margins (could be like css)

function Margin(props) {
  const { left, right, top, bottom, children } = props

  const [Rect, rect] = useRect()

  return (
    <svg x={0} y={0} width={'100%'} height={'100%'}>
      <Rect />
      <svg x={left} width={rect.width - left - right} y={top} height={rect.height - top - bottom}>
        {children}
      </svg>
    </svg>
  )
}

Margin.propTypes = {
  left: PropTypes.number,
  right: PropTypes.number,
  top: PropTypes.number,
  bottom: PropTypes.number,
  children: PropTypes.node.isRequired,
}

Margin.defaultProps = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
}

export default Margin
